import gql from "graphql-tag";

export default gql`
  query OwnedTicketData($id: Int!) {
    me {
      __typename
      ... on User {
        profile {
          id
          ... on Child {
            municipality {
              name
            }
          }
          ... on Parent {
            municipality {
              name
            }
          }
        }
      }
    }
    ownedTicket(id: $id) {
      __typename
      ... on Error {
        message
      }
      ... on GrantedTicket {
        __typename
        id
        code
        timesUsed
        ticketCollection {
          serviceProvider {
            name
          }
          style {
            overlayColor
            uploads
          }
          ticket {
            title
            canBeUsedBy
            validTo
            validFrom
            minAge
            entryLimit
            linkUrl
            description
          }
        }
      }
      ... on BookedTicket {
        __typename
        id
        code
        timesUsed
        ticketCollection {
          serviceProvider {
            name
          }
          ticket {
            title
            canBeUsedBy
            validTo
            linkUrl
            validFrom
            entryLimit
            minAge
            description
            discount
          }
          style {
            overlayColor
            uploads
          }
        }
      }
    }
  }
`;
